/**
 * Função auxiliar para sort baseado em uma lista padrão.
 * @param {*} a Variavel um para analize
 * @param {*} b Variavel dois para analise
 * @param {Array} base Lista base para analise
 * @returns {Integer} Retorno para sort.
 */
export const compareIndexOf = (a, b, base) => {
  if (base.indexOf(a) === -1 && base.indexOf(b) === -1) {
    if (typeof a === 'string') {
      return a.localeCompare(b)
    } else {
      return a < b ? 1 : -1
    }
  }
  if (base.indexOf(a) === -1) {
    return 1
  }
  if (base.indexOf(b) === -1) {
    return -1
  }
  // Caso nenhum os itens estejam na lista base
  return base.indexOf(a) < base.indexOf(b) ? -1 : 1
}
